<!--
 - Author : wanghongling.
 - Date   : 2020/12/23.
 - File   : safe.名厨亮灶安全综合评估
 -->

<template>
  <layer title="安全综合评估" titleClass="01" width="326px" padding="20px 20px">
    <div class="ming-safe">
      <el-select class="name-list" v-model="selectValue" value-key="departmentId" placeholder="请选择"
                 @change="changeValFnc">
        <el-option
            v-for="item in options"
            :key="item.departmentId"
            :label="item.departmentName"
            :value="item">
        </el-option>
      </el-select>
      <!--<liquid-fill id="safeFills" :liquid-list="safeFillData"></liquid-fill>-->
      <custom-dashboard id="dashboards" :dashboardObj="safeDashboardObj"></custom-dashboard>
      <div class="safe-info">
        <p>{{ canteenInfo.orgName }}</p>
        <p>{{ canteenInfo.departmentName }}</p>
      </div>
    </div>
  </layer>
</template>

<script>
import customDashboard from '../echarts/customDashboard'

export default {
  name: 'safe',
  components: {customDashboard},
  data() {
    return {
      orgId: this.$store.getters.userInfo.orgId,
      safeFillData: {
        date: 0,
        width: '80px',
        height: '80px',
        margin: '30px 0',
        radius: '100%',
        bgColor: 'rgba(0,157,159,0.1)',
        borderColor: '#02536e',
        shadowColor: '#05575f',
        theTop: '120px',
        text: '安全指数',
        labelFontSize: 19,
        colorList: ['rgba(59,148,148,0.5)', 'rgba(5,87,95,0.7)', 'rgba(5,118,117,1)']
      },
      options: [],
      selectValue: '',
      canteenInfo: {},
      safeDashboardObj: {
        width: '160px',
        height: '160px',
        text: '',
        value: 0
      }
    }
  },
  async mounted() {
    await this.getCanteenList()
    this.getSafeLevel()
    this.safeWsMsg()
    this.getSafetyIndex()
  },
  methods: {
    /**
     * @description: 获取异常安全指数
     * @author: linwen linwen@fjxhx.com
     * @createDate: 2021-01-19 16:31
     */
    getSafetyIndex() {
      this.$request.exceptionSafetyindexScreenAppGet({
        orgId: this.$store.getters.userInfo.orgId,
        deptId: this.deptId
      }).then(res => {
        console.log('__安全预警__获取异常安全指数__获取异常安全指数__:', res);
        if (!this.$utils.isEmptyObject(res)) {
          this.safeDashboardObj.text = res.safetyIndex
          this.safeDashboardObj.value = res.score
        }
      })
    },
    /**
     * @author wanghongling
     * @createTime 2020/12/24
     * @description websocket监听数据
     */
    safeWsMsg() {
      window.getSafeInfo = e => {
        console.log(e, 'websocket监听数据')
        this.getSafeLevel()
        this.getSafetyIndex()
      }
    },
    /**
     * @Description:选择框切换
     * @author wanghongling
     * @createDate 2020/12/23
     */
    changeValFnc(e) {
      this.canteenInfo = e
      this.getSafeLevel()
      this.$emit('changeValFnc', e.departmentId)
    },
    /**
     * @Description:获取名厨亮灶食堂列表
     * @author wanghongling
     * @createDate 2020/12/24
     */
    getCanteenList() {
      return this.$request.constramanageDeptOrgListGet({orgId: this.orgId}).then(res => {
        console.log(`获取名厨亮灶食堂列表:`, res)
        if (!this.$utils.isEmptyObject(res)) {
          this.selectValue = res[0].departmentName
          this.canteenInfo = res[0]
          this.options = res
        }
      }).catch(e => {
        console.error(e)
      })
    },
    /**
     * @Description:获取名厨亮灶安全等级
     * @author wanghongling
     * @createDate 2020/12/24
     */
    getSafeLevel() {
      this.$request.exceptionLightTotalGet({departmentId: this.canteenInfo.departmentId}).then(res => {
        console.log('获取名厨亮灶安全等级', res)
        this.safeFillData.date = res
      }).catch(e => {
        console.error(e)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ming-safe {
  position: relative;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0 0 -10px 0px;

  .safe-info {
    p {
      color: #00fffc;
      margin-bottom: 15px;
      font-size: 16px;
    }

    p:last-child {
      font-size: 15px;
      color: #83adbb;
      margin-bottom: 0;
    }
  }

  .name-list {
    position: absolute;
    top: -40px;
    right: -5px;
    width: 120px;

    /deep/ .el-input__inner {
      background-color: #06303d;
      border: 1px solid #06303d;
      font-size: 15px;
      color: #00f17d;
      height: 35px;
      line-height: 35px;
    }

    /deep/ .el-input__icon {
      line-height: 35px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mingChu/safe.vue